export default __webpack_public_path__ + "56c6ef4424d0d344606f4ba95438cf21.svg";